if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      getSelectedAddonVariantId() {
          const addonVariantsEl = document.querySelector('#addon-option-variants');
          const addonVariants = JSON.parse(addonVariantsEl.textContent);

          const selectedOptions = {};
          document.querySelectorAll('.product__add--filter-product-option').forEach(optionEl => {
            const optionName = optionEl.dataset.optionName;
            const activeValueEl = optionEl.querySelector('.option-value.active');
            if (activeValueEl) selectedOptions[optionName] = activeValueEl.dataset.value;
          });

          const matchedVariant = addonVariants.find(v => {
            return Object.entries(selectedOptions).every(([key, val]) => v.options.includes(val));
          });

          return matchedVariant ? matchedVariant.id : null;
      }

      getSelectedAddonSellingPlan() {
        const radioInput = document.querySelector('.product__add--filter-variants .rc_widget__option.rc-option--active');
        if (!radioInput) return null;

        // Check if it has the attribute
        if (!radioInput.hasAttribute('data-option-subsave')) return null;
        const group = radioInput.closest('.rc-template__button-group');
        if (!group) return null;
        const select = group.querySelector('select[name="selling_plan"]');
        if (!select) return null;
        return select.value || null;
      }

      addAddonProduct(mainProductId){
        const addonVariantId = this.getSelectedAddonVariantId();
        if (!addonVariantId) return;
        const addonQuantity = 1;
        const sellingPlanId = this.getSelectedAddonSellingPlan();
        const payload = {
            items: [
              {
                id: addonVariantId,
                quantity: addonQuantity,
                properties: {
                  '_main-product': mainProductId
                }
              }
            ]
        };

        if (sellingPlanId) {
            payload.items[0].selling_plan = sellingPlanId;
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(payload)
        })
          .then(res => res.json())
          .then(() => {
            // Get updated sections JSON (not HTML page)
            const sections = [
              'cart-notification-button',
              'cart-icon-bubble'
            ];

            return fetch(`${window.routes.cart_url}?sections=${sections.join(',')}`, {
              headers: { 'X-Requested-With': 'XMLHttpRequest' }
            });
          })
          .then(res => res.json())
          .then(sectionsHTML => {
            Object.entries(sectionsHTML).forEach(([id, html]) => {
              const el = document.getElementById(id);
              if (el) el.innerHTML = html;
            });
            window.ReChargeWidget.destroyAllWidgets()
            initRechargeWidgets();
            const interval = setInterval(() => {
              if(window.initRechargeOptions) window.initRechargeOptions(interval);
            }, 100);
          })
          .catch(err => console.error('Addon add failed:', err));

      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        window.currentVariantId = formData.get('id');
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
              const productContainer = this.form.closest('.product__info-container');
              if (productContainer && productContainer.querySelector('.product__add--filter-variants.active')) {
                this.addAddonProduct(window.currentVariantId);
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
